import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { Breadcrumb, Button, Col, Row, Tag, Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import CustomLayout from '@/common/Layout/index';
import emptyState from '../../../admin-doa-envelope/images/empty.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from '@/common/Content/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllSubCategories,
  getSubCategoryById,
  getAllCategories
} from '../../redux/slice';
import Pencil from '@/features/initiate-envelope/images/Pencilsvg';
import AddModal from './AddModal';
import EditModal from './EditModal';
// import { getAllCategories } from '@/features/dashboard/redux/slice';

const SubCategories = () => {
  const { categories, get_subcategorylist, subcategory_by_id, byIdLoading } =
    useSelector((state) => state.settings);

  console.log('get_subcategorylist', get_subcategorylist);
  console.log('categories', categories);
  // const { all_subcategories, sbu_pagination, subcategory_by_id, byIdLoading } =
  //   useSelector((state) => state.settings);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id, setId] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [categorySearch, setCategorySearch] = useState('');
  const [page, setPage] = useState(1);

  const showModal = () => {
    setIsModalOpen(true);
    setCategorySearch('');
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showEditModal = (id) => {
    let payload = {
      id: id,
      user: 'admin'
    };
    dispatch(getSubCategoryById(payload));
    handleGetCategories();
    setCategorySearch('');
    setIsEditModalOpen(true);
  };
  const handleEditOk = () => {
    setIsEditModalOpen(false);
  };
  const handleEditCancel = () => {
    setIsEditModalOpen(false);
  };

  const dispatch = useDispatch();

  const handleGetCategories = () => {
    let payload = categorySearch !== '' ? { search: categorySearch } : {};
    dispatch(getAllCategories(payload));
  };

  useEffect(() => {
    handleGetCategories();
  }, [categorySearch]);

  useEffect(() => {
    handleGetCategories();
  }, []);

  const handleGetSubCategories = () => {
    // let payload =
    //   search !== '' ? { search: search } : { search: search, page: page };
    let payload = {
      search: search,
      page: page,
      user: 'admin' // Add the user property here
    };
    if (search === '') {
      delete payload.search; // Remove `search` if it's not needed
    }
    dispatch(getAllSubCategories(payload));
  };

  const handleCategorySearchChange = (e) => {
    setCategorySearch(e);
    handleGetCategories();
  };

  useEffect(() => {
    handleGetSubCategories();
  }, [search, page]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // const category_name = categories.find(
  //   (category) => category.id === get_subcategorylist.category_id
  // );

  const data = get_subcategorylist;

  // const data = 0;
  const columns = [
    {
      width: '40%',
      title: 'Sub-Category Name',
      dataIndex: 'sub_category_name',
      key: 'sub_category_name',
      render: (sbg) => (
        <Tooltip placement="top" title={sbg}>
          <div className="text-caps">
            {sbg?.length > 30 ? `${sbg?.substring(0, 55)}...` : sbg}
          </div>
        </Tooltip>
      )
    },
    {
      width: '30%',
      title: 'Category Name',
      dataIndex: ['category', 'category_name'],
      key: 'category_name',
      render: (sbg) => (
        <Tooltip placement="top" title={sbg}>
          <div className="text-caps">
            {' '}
            {sbg?.length > 25 ? `${sbg?.substring(0, 25)}...` : sbg}
          </div>
        </Tooltip>
      )
    },
    {
      width: '10%',
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (status) => (
        <Tag color={status === true ? 'green' : 'red'}>
          {status === true ? 'Active' : 'Deactivated'}
        </Tag>
      )
    },
    {
      align: 'center',
      width: '10%',
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id) => (
        <Tooltip title="Edit">
          <span
            className="cursor-pointer"
            onClick={() => {
              showEditModal(id);
            }}
          >
            <Pencil />
          </span>
        </Tooltip>
      )
    }
  ];

  return (
    <CustomLayout sider={false}>
      {' '}
      <div className={`${styles.breadcrub_container}`}>
        {' '}
        <Row>
          <Col span={19}>
            <Breadcrumb separator={<RightOutlined />}>
              <Breadcrumb.Item href="/settings">Settings</Breadcrumb.Item>

              <Breadcrumb.Item
                className="sfprotext-medium font-14"
                href="/settings/categories"
              >
                Configure Sub-Categories
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col className="text-right" span={4}>
            <Button
              onClick={showModal}
              className="font-14 sfprotext-bold "
              type="primary"
            >
              Add Sub-Category
            </Button>
          </Col>
        </Row>
      </div>
      <Row>
        <Col span={18}>
          <div className="mt-3 font-16 sfprotext-bold">Sub-Categories</div>
        </Col>
        <Col span={6}>
          <SearchBar
            onChange={handleSearchChange}
            className={`mt-3 ${styles.createdSearch}`}
            inputProps={{
              placeholder: 'Search by sub-category name'
            }}
          />
        </Col>
      </Row>
      {data?.length === undefined ? (
        <>
          <div className="df-jc-ac mt-5">
            <img src={emptyState} />
          </div>
          <div className="df-jc-ac mt-3">
            <div className="sfprotext-regular font-14">
              You haven’t created any categories yet.
            </div>
          </div>
          <div className="df-jc-ac mt-3">
            <Button
              onClick={showModal}
              type="primary"
              className="sfprotext-bold font-14"
            >
              Add Category
            </Button>
          </div>
        </>
      ) : (
        <CustomTable
          //loading={tableLoading}
          rowKey={(id) => id.id.id}
          className={`mt-4 ${styles.custom_table}`}
          /*  rowSelection={true} */
          dataSource={data}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setPage(page);
            },
            pageSize: 20,
            // total: sbu_pagination?.total_records,
            showSizeChanger: false
          }}
        />
      )}
      {isModalOpen ? (
        <AddModal
          handleCategorySearchChange={handleCategorySearchChange}
          categories={categories}
          get_subcategorylist={get_subcategorylist}
          handleGetSubCategories={handleGetSubCategories}
          setIsModalOpen={setIsModalOpen}
          isModalVisible={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        />
      ) : null}
      {isEditModalOpen ? (
        <EditModal
          byIdLoading={byIdLoading}
          handleCategorySearchChange={handleCategorySearchChange}
          setCategorySearch={setCategorySearch}
          subcategory_by_id={subcategory_by_id?.[0]}
          categories={categories}
          get_subcategorylist={get_subcategorylist}
          handleGetSubCategories={handleGetSubCategories}
          id={id}
          setId={setId}
          //approverById={approverById?.[0]}
          setIsEditModalOpen={setIsEditModalOpen}
          isEditModalVisible={isEditModalOpen}
          onOk={handleEditOk}
          onCancel={handleEditCancel}
        />
      ) : null}
    </CustomLayout>
  );
};

export default SubCategories;
